import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { UtilCommonModule } from '../common/util/module'
import { LocaleModule } from '../common/locale/module'
import { FormsModule } from '@angular/forms'
import { UtilReleaseNotesModule } from '../common/util.releaseNotes/module'
import { SystemMediaLibraryView } from './views/systemMediaLibraryView.component'
import { NgbModalModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap'
import { RouterModule } from '@angular/router'

@NgModule({
  imports: [
    CommonModule,
    UtilCommonModule,
    RouterModule.forChild([]),
    LocaleModule.forChild(),
    FormsModule,
    UtilReleaseNotesModule,
    NgbNavModule,
    NgbModalModule,
  ],
  declarations: [
    SystemMediaLibraryView,
  ],
  exports: [
  ],
})
export class SystemModule {}
